import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled application error:', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="grid min-h-screen place-items-center bg-bg px-5 py-12 text-center">
          <div className="max-w-md">
            <h1 className="font-display text-[36px] leading-tight">Xatolik yuz berdi</h1>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-5 inline-flex min-h-11 items-center justify-center rounded-[12px] bg-forest px-5 text-[14px] font-medium text-white transition-colors hover:bg-forest/90"
            >
              Qayta yuklash
            </button>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}
